import React from 'react';
import {
  getLoginURI,
} from '../../utils/api';
import '../../index-override.css';

const styles = {
  root: {
    margin: '8px',
  },
  table: {
      width: '100%',
      height: '40%',
  },
  tableRow: {
      backgroundColor: 'white',
      width: '15%',
      height: '40%',
      textAlign: 'center',
      verticalAlign: 'middle',
  },
  tableRowWide: {
    backgroundColor: 'white',
    width: '55%',
    height: '40%',
    textAlign: 'justify',
  },
  logoDiv: {
      marginLeft: '80px',
  },
  logoImg: {
      width: '194px',
      height: '125px',
      maxWidth: 'none',
  },
  portalImg: {
      width: '149px',
      height: '39px',
      maxWidth: 'none',
  },
  userImgDiv: {
    textAlign: 'center',
    marginLeft: '80px',
    maxWidth: 'none',
  },
  userImg: {
      width: '160px',
      height: '72px',
      maxWidth: 'none',
  },
  malloryBellDiv: {
    width: '160px',
    height: '72px',
    maxWidth: 'none',
  },
  landingPageImg: {
    width: '627px',
    height: '425px',
    maxWidth: 'none',
  },
  landingPageDiv: {
      marginLeft: '40px',
  },
  commercialMortgageLendingProgramDiv: {
      textAlign: 'center',
  },
  commercialMortgageLendingProgramImg: {
    width: '715px',
    height: '120px',
    maxWidth: 'none',
  },
  portalButton: {
    backgroundColor: 'white',
    border: 'none',
  }
};

const amFamLogoSrc = require('../../assets/investments_logo.jpg');
const mortgagesPortalSrc = require('../../assets/mortgages_portal.jpg');
const jeffCapaulSrc = require('../../assets/Jeff_Capaul.png');
const lauraMcgrawSrc = require('../../assets/Laura_McGraw.png');
const malloryBellSrc = require('../../assets/Mallory_Bell.png');
const landingPageImageSrc = require('../../assets/25_w_main.jpg');
const commercialMortgageLendingProgramSrc = require('../../assets/commercial_mortgage_lending_program.png');

export default function Index() {
  return (
    <div style={styles.root}>
      <table style={styles.table} cellspacing="0" cellpadding="0" border="0">
        <tbody>
          <tr>
            <td style={styles.tableRow}><br/>
            </td>
            
            <td style={styles.tableRow}>
              <div style={styles.logoDiv}>
                <img src={amFamLogoSrc} style={styles.logoImg} alt="AmFam Investments Logo" title="AmFam Investments Logo" />
                <br/>
                <button style={styles.portalButton} type="button" onClick={getLoginURI}>
                  <img src={mortgagesPortalSrc} style={styles.portalImg} alt="Mortgages Portal" /><br/>
                </button>
                <a href="mailto:jcapaul@amfam.com" title="jcapaul@amfam.com">
                  <img src={jeffCapaulSrc} style={styles.userImg} alt="Jeff Capaul" title="Jeff Capaul" />
                </a>
                <br/>
              </div>
              
              <div style={styles.userImgDiv}>
                <a href="mailto:lmcgraw@amfam.com">
                  <img src={lauraMcgrawSrc} style={styles.userImg} alt="Laura McGraw" title="Laura McGraw" />
                </a>
                <span> </span>
              </div>
              
              <div style={styles.userImgDiv}>
              </div>

              <div style={styles.userImgDiv}>
                <a href="mailto:mbel4@amfam.com">
                  <img src={malloryBellSrc} style={styles.userImg} alt="Mallory Bell" title="Mallory Bell" />
                </a>
                <br/>
              </div>
            </td>
            
            <td>
              <br/>
            </td>
            
            <td>
              <br/>
            </td>
            
            <td style={styles.tableRowWide}>
              <div style={styles.landingPageDiv}>&nbsp;&nbsp; 
                <img src={landingPageImageSrc} style={styles.landingPageImg} alt="25 W Main location" title="25 W Main location" />
                <br/>
              </div>
            </td>
            
            <td style={styles.tableRow}>
              <br/>
            </td>
          </tr>

          <tr>
            <td colspan="6">
              <div style={styles.commercialMortgageLendingProgramDiv}>
                <img src={commercialMortgageLendingProgramSrc} style={styles.commercialMortgageLendingProgramImg} alt="Commercial Mortgage Lending Program" />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
